import { observer } from "mobx-react-lite";
import { useState } from "react";
import styled from "styled-components";

import { useStores } from "../../stores/useStores";
import { color } from "../../theme/color";
import { Dialog } from "../ui/Dialog";
import { SearchBox } from "../ui/SearchBox";

/** Picks a song, or a version of it, to add to the end of a setlist. */
export const AddSongToSetlistDialog = observer(function AddSongToSetlistDialog(props: { setlistId: string; onClose(): void }) {
    const { library } = useStores();
    const [query, setQuery] = useState("");
    const options = library.findSongs(query).flatMap((song) => library.versionsOf(song.id).map((sheet) => ({ sheet, song })));

    async function add(chordSheetId: string) {
        await library.change((l) => l.addToSetlist(props.setlistId, chordSheetId));
        props.onClose();
    }

    return (
        <Dialog title="Add a song" onClose={props.onClose}>
            <SearchBox autoFocus label="Search songs" placeholder="Search title or artist" value={query} onChange={setQuery} />
            <Options>
                {options.map(({ sheet, song }) => (
                    <li key={sheet.id}>
                        <Option type="button" onClick={() => add(sheet.id)}>
                            {song.title}
                            {sheet.name && <Version>, {sheet.name}</Version>}
                        </Option>
                    </li>
                ))}
            </Options>
        </Dialog>
    );
});

const Options = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    max-height: 50vh;
    overflow: auto;
`;

const Option = styled.button`
    width: 100%;
    min-height: 48px;
    padding: 8px 12px;
    border: 0;
    border-radius: 10px;
    background: transparent;
    text-align: left;
    font-size: 15px;
    cursor: pointer;

    &:hover {
        background: ${color.accentSofter};
    }
`;

const Version = styled.span`
    color: ${color.textMuted};
`;
